/**
 * Canonical trade ordering for the equipment picker, equipment tab and any
 * UI that groups by trade. Survives the eventual deletion of the
 * equipment-tab handler types (spec 2026-05-05-03).
 *
 * Used as a *fallback* ordering — the source of truth for which trades exist
 * is the `/asset-types` endpoint with `kind === "trade"`. This list only
 * decides *order* when an asset-type ships in this list; anything else falls
 * back to alphabetical.
 */
export const SPEC_TRADE_CODES = [
  'trade_struct',
  'trade_roof',
  'trade_facade',
  'trade_openings',
  'trade_hvac',
  'trade_elec',
  'trade_plumbing',
  'trade_fire',
  'trade_lift',
  'trade_site',
] as const

export type SpecTradeCode = (typeof SPEC_TRADE_CODES)[number]
